import { Button, message } from "antd";
import useTranslation from "next-translate/useTranslation";
import { useRouter } from "next/router";
import { EntityProps } from "../../@types/enrollments";
import { Container } from "./styles";

const ItemsToCourseAuthor = ({ entity }: ItemsToCourseAuthorProps) => {
  const router = useRouter();
  const { t } = useTranslation();

  const isCoursePage = entity.className === "Vico068\\CourseTools\\Course";

  function handleAccessMyCourse() {
    if (!entity.first_module_slug || !entity.first_lesson_slug) {
      return message.error({
        content: t("common:weCouldntFind"),
      });
    }

    if (isCoursePage) {
      router.push(
        `/courses/${entity.slug}/${entity.first_module_slug}/${entity.first_lesson_slug}`,
      );
    }
  }

  return (
    <Container>
      <Button type="primary" onClick={handleAccessMyCourse}>
        {isCoursePage ? t("common:accessMyCourse") : t("common:accessContent")}
      </Button>
    </Container>
  );
};

interface ItemsToCourseAuthorProps {
  entity: EntityProps;
}

export default ItemsToCourseAuthor;
